import { render } from "./FileUploadPage.vue?vue&type=template&id=0216e9da"
import script from "./FileUploadPage.vue?vue&type=script&lang=js"
export * from "./FileUploadPage.vue?vue&type=script&lang=js"
script.render = render

export default script